import type { PendingShopifyIntegrationCookie } from "schemas/cookies";

import * as React from "react";

import { getPublisherUrl } from "@v2/utils/env";
import { useCookies } from "react-cookie";
import {
  PENDING_SHOPIFY_INTEGRATION_COOKIE,
  pendingShopifyIntegrationCookieSchema,
} from "schemas/cookies";

const usePendingShopifyIntegrationCookie = () => {
  const [cookies, setCookie] = useCookies([PENDING_SHOPIFY_INTEGRATION_COOKIE]);

  const pendingShopifyIntegrationCookie = React.useMemo(() => {
    if (!cookies.replo_pending_shopify_integration) {
      return null;
    }
    const parsedCookie = pendingShopifyIntegrationCookieSchema.safeParse(
      cookies.replo_pending_shopify_integration,
    );
    if (!parsedCookie.success) {
      return null;
    }
    return parsedCookie.data;
  }, [cookies.replo_pending_shopify_integration]);

  const setPendingShopifyIntegrationCookie = (
    pendingShopifyIntegrationCookie: PendingShopifyIntegrationCookie,
  ) => {
    const validatedCookie = pendingShopifyIntegrationCookieSchema.parse(
      pendingShopifyIntegrationCookie,
    );
    return setCookie(
      PENDING_SHOPIFY_INTEGRATION_COOKIE,
      JSON.stringify(validatedCookie),
      {
        path: "/",
        maxAge: 60 * 10, // 10 minutes
        sameSite: "lax",
        // Note (Noah, 2025-09-04, REPL-19153): In production, we want to make sure to set this
        // on the root domain, so that it's accessible to the backend (which is at api.replo.app)
        domain: getPublisherUrl().includes("replo.app")
          ? "replo.app"
          : undefined,
      },
    );
  };

  return {
    pendingShopifyIntegrationCookie,
    setPendingShopifyIntegrationCookie,
  };
};

export default usePendingShopifyIntegrationCookie;
